export const RoutesMap = {
    Home: '/',
    Cards: '/cards',
    Realms: '/realms'
}
